// Vector paths preserved from the supplied design source.
export const iconMarkup: Record<string, string> = {
  home: '<path d="m3 11 9-8 9 8M5 10v11h5v-7h4v7h5V10"/>',
  alert: '<path d="M12 3 2 21h20L12 3Z"/><path d="M12 9v5m0 3v1"/>',
  flame:
    '<path d="M12 2c1 5-4 6-4 10-2-1-2-3-2-3-5 7-2 13 6 13 7 0 10-7 6-13-1 3-3 3-3 3 1-6-3-10-3-10Z"/><path d="M12 14c-4 4-2 7 0 7s4-3 0-7Z"/>',
  pin: '<path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>',
  building:
    '<path d="M6 22V5h12v17M3 22h18M10 5V2h4v3M9 9h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1M11 22v-3h2v3"/>',
  city: '<path d="M2 22h20M4 22V8h7v14m0-17h8v17M7 11v1m0 3v1m8-8v1m0 3v1m0 3v1M13 5V2h4v3"/>',
  users:
    '<circle cx="12" cy="7" r="3"/><path d="M6 21v-4a6 6 0 0 1 12 0v4H6Zm-3-1v-4a5 5 0 0 1 2-4m16 8v-4a5 5 0 0 0-2-4"/><path d="M4 4a3 3 0 0 0 0 6m16-6a3 3 0 0 1 0 6"/>',
  truck:
    '<path d="M2 5h12v12H2V5Zm12 5h4l4 4v3h-8M17 10v4h5"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/>',
  radio:
    '<circle cx="12" cy="10" r="2"/><path d="m9 22 3-10 3 10M7 5a7 7 0 0 0 0 10M17 5a7 7 0 0 1 0 10M4 2a11 11 0 0 0 0 16M20 2a11 11 0 0 1 0 16"/>',
  tree: '<path d="m12 2-6 8h3l-5 7h6v5h4v-5h6l-5-7h3L12 2Z"/>',
  flask: '<path d="M8 2h8M9 2v7L3 20c-.5 1 .2 2 1 2h16c.8 0 1.5-1 1-2L15 9V2M6 16h12"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v1"/>',
  search: '<circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6"/>',
  chevron: '<path d="m6 9 6 6 6-6"/>',
  arrow: '<path d="M3 12h17m-6-6 6 6-6 6"/>',
  bell: '<path d="M5 9a7 7 0 0 1 14 0v7l2 3H3l2-3V9Zm5 13h4M12 2V1"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 22v-2a8 8 0 0 1 16 0v2"/>',
  layers: '<path d="m12 2 10 6-10 6L2 8l10-6Zm-10 11 10 6 10-6M2 18l10 6 10-6"/>',
  shield: '<path d="m12 2 9 4v6c0 6-9 10-9 10S3 18 3 12V6l9-4Z"/><path d="m8 12 3 3 5-6"/>',
  settings:
    '<path d="m9 2-1 3-3 1-2 3 2 3-1 3 3 3 3-1 2 3 4-1 1-3 3-1 1-4-2-2 1-4-3-2-3 1-2-3-3 1Z"/><circle cx="12" cy="11" r="3"/>',
  clipboard: '<path d="M8 4H4v18h16V4h-4M9 2h6v5H9V2Zm-2 9h10M7 15h10M7 19h6"/>',
  book: '<path d="M12 5C9 3 5 3 2 4v16c4-1 7-1 10 1 3-2 6-2 10-1V4c-3-1-7-1-10 1v16"/>',
  chart: '<path d="M3 3v18h19M7 17v-4h3v4H7Zm5 0V8h3v9h-3Zm5 0V3h3v14h-3Z"/>',
  map: '<path d="m2 5 7-3 6 3 7-3v17l-7 3-6-3-7 3V5Zm7-3v17m6-14v17"/>',
  file: '<path d="M5 2h9l5 5v15H5V2Zm9 0v6h5M8 12h8M8 16h8"/>',
  report: '<path d="M4 2h16v20H4V2Zm4 5h8m-8 5h8m-8 5h5"/>',
  siren:
    '<path d="M6 19V10a6 6 0 0 1 12 0v9M3 19h18v3H3v-3M1 7l2 1M4 2l2 2m6-4v2m8 0-2 2m5 3-2 1"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/>',
  refresh: '<path d="M20 8a9 9 0 0 0-15-3L2 8m0-6v6h6m-4 8a9 9 0 0 0 15 3l3-3m0 6v-6h-6"/>',
  close: '<path d="m6 6 12 12M6 18 18 6"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  empty: '<path d="M3 3h18v18H3V3Zm0 13h5l2 3h4l2-3h5"/>',
  network:
    '<circle cx="12" cy="4" r="2"/><circle cx="4" cy="19" r="2"/><circle cx="20" cy="19" r="2"/><path d="m11 6-6 11m8-11 6 11M6 19h12"/>',
};
